import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import TenderForMaterialMain from "./TenderForMaterial/tenderForMaterialMain";
import TenderForWorkServiceMain from "./TenderForWorkService/tenderForWorkServiceMain";

const Materails: React.FC<any> = (props) => {
  const { control, reset, setValue, watch, handleSubmit } = useFormContext();

  const previousFormDate = watch();

  useEffect(() => {
    console.log("previousFormDate", previousFormDate);
  }, []);
  return (
    <>
      {previousFormDate.tenderFor === "Material" && (
        <TenderForMaterialMain prev={props.prev} next={props.next} />
      )}
      {previousFormDate.tenderFor === "Service / Works" && (
        <TenderForWorkServiceMain prev={props.prev} next={props.next} />
      )}
    </>
  );
};

export default Materails;
